/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  document.addEventListener('theme:variant:change', (e) => {
    const id = e.detail.variant.id;
    const params = new URLSearchParams(document.location.search);
    params.set('variant', id);
    fetch(window.location.pathname + '?' + params.toString())
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const currents = document.querySelectorAll('[data-scent-metafield]');
        const newCodes = html.querySelectorAll('[data-scent-metafield]');
        currents.forEach((current, i) => {
          current.innerHTML = newCodes[i].innerHTML;
          current.setAttribute(
            'data-scent-metafield',
            newCodes[i].getAttribute('data-scent-metafield')
          );
        });
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* Updates metafield content in file 'scent_description */
(function () {
  document.addEventListener('theme:variant:change', (e) => {
      const variantId = e.detail.variant.id;
      const variantDataElements = document.querySelectorAll('[id^="variant-data-"]');
      
      variantDataElements.forEach(variantDataElement => {
          const variantData = JSON.parse(variantDataElement.textContent);
          const selectedVariant = variantData.find(variant => variant.id === variantId);
          
          if (selectedVariant) {
              const variantDescriptionId = variantDataElement.id.replace('variant-data-', 'variant-description-');
              const variantDescriptionElement = document.getElementById(variantDescriptionId);
              
              if (variantDescriptionElement) {
                  variantDescriptionElement.innerHTML = selectedVariant.variant_description;
                  variantDescriptionElement.classList.add('updated');
              }
          }
      });
  });
})();